export default __webpack_public_path__ + "static/n_m illustration-292f843c33e1558846e875f76bb88db2.png";